import TimezoneUserPrefRoute from './TimezoneUserPrefRoute'

const routes = [new TimezoneUserPrefRoute()]

export default routes
